import { useEffect, useState } from "react";
import CustomModel from "../../Utility/CustomModel";

export const PanelRefAuthorGroup = ({
  handleCancel,
  editor,
  show,
  refId,
  setData,
  authGroup,
  setAuthGroup,
}) => {
  const fields = [
    {
      name: "sur-name",
      label: "Surname",
      type: "text",
      default: "",
      editable: true,
    },
    {
      name: "given-name",
      label: "Given Name",
      type: "text",
      default: "",
      editable: true,
    },
  ];
  const [authorData, setAuthorData] = useState([]);

  const handleChange = (e, i) => {
    const { name, value } = e.target;
    setAuthorData((prev) =>
      prev.map((item, index) =>
        index === i ? { ...item, [name]: value } : item
      )
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const combinedAuthors = authorData
      .map((author) => {
        return Object.values(author)
          .filter((val) => val && val.trim() !== "")
          .join(" ");
      })
      .join(", ");

    setData((prevData) => ({
      ...prevData,
      "person-group": combinedAuthors,
    }));
    setAuthGroup(authorData);
    handleCancel();
  };

  const handleAddAuthor = (index) => {
    const emptyAuthor = fields.reduce((acc, field) => {
      acc[field.name] = field?.default || "";
      return acc;
    }, {});
    setAuthorData((prevData) => {
      const newData = [...prevData];
      newData.splice(index + 1, 0, { ...emptyAuthor }); // insert after current
      return newData;
    });
  };

  const handleRemoveAuthor = (index) => {
    setAuthorData((prevData) => {
      if (prevData.length === 1) return prevData; // Prevent deleting the last row
      const newData = [...prevData];
      newData.splice(index, 1);
      return newData;
    });
  };

  useEffect(() => {
    if (refId && authGroup.length > 0) {
      setAuthorData(authGroup);
    } else {
      const initial = fields.reduce((acc, field) => {
        acc[field.name] = field?.default || "";
        return acc;
      }, {});

      setAuthorData([initial]);
    }
  }, []);

  return (
    <div className="w-full border-grey bg-white border rounded-[8px]">
      <form onSubmit={handleSubmit} className="w-full p-4  ">
        {authorData.length ? (
          authorData.map((data, i) => (
            <div className={`flex flex-col gap-4 mb-4  w-full ${(authorData.length-1)==i ?"":"border-b border-grey pb-5"}`}>
              {fields.map((field, index) => {
                const isEditable = field.editable || false;

                const isTrulyReadOnly = !field.editable;

                const inputStyle = {
                  padding: "2px 10px",
                  flexGrow: 1,
                  ...(isTrulyReadOnly
                    ? {
                        border: "none",
                        outline: "none",
                        backgroundColor: "#f9f9f9",
                      }
                    : { border: "1px solid #ccc", outline: "none" }),
                };

                return (
                  <div key={index} className={`flex flex-col gap-2 `}>
                    <div className="flex justify-between">
                      <label className="ref-form-label text-primary text-[16px] font-semibold">
                        {field.label}
                      </label>

                      {field.name === "sur-name" && (
                        <div className="flex gap-2">
                          <button
                          type="button"
                            title="Add Row"
                            className="text-nowrap text-refbtnhover hover:bg-refbtnhover hover:text-white p-[2px] rounded-[3px]"
                            onClick={() => handleAddAuthor(i)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="icon icon-tabler icons-tabler-outline icon-tabler-plus"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M12 5l0 14" />
                              <path d="M5 12l14 0" />
                            </svg>
                          </button>
                          <button
                          type="button"
                            title="Remove Row"
                            className=" text-nowrap text-red hover:text-white hover:bg-red rounded-[3px] p-[2px] cursor-pointer"
                            onClick={() => handleRemoveAuthor(i)}
                            disabled={authorData.length === 1}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M4 7l16 0" />
                              <path d="M10 11l0 6" />
                              <path d="M14 11l0 6" />
                              <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                              <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                    <input
                      className="text-primary text-[16px]"
                      type={field.type}
                      name={field.name}
                      value={data[field.name]}
                      onChange={(e) => handleChange(e, i)}
                      style={inputStyle}
                      readOnly={!isEditable}
                    />
                  </div>
                );
              })}
              {/* <div className="flex justify-end text-primary  gap-2 w-fit">
                <button
                  type="button"
                  className="px-4 py-1 border border-grey cursor-pointer text-nowrap"
                >
                  Add Row
                </button>
                <button
                  type="button"
                  className="px-4 py-1 border border-grey text-nowrap  cursor-pointer"
                  onClick={() => handleRemoveAuthor(i)}
                  disabled={authorData.length === 1}
                >
                  Delete Row
                </button>
              </div> */}
            </div>
          ))
        ) : (
          <></>
        )}
        <div className="ml-auto w-full">
          <div className="flex py-3 ml-auto gap-4 justify-end">
            <button
              className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
              onClick={() => handleCancel()}
            >
              {" "}
              Cancel
            </button>
            <button
              className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
              onClick={(e) => handleSubmit(e)}
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};
